import React, { useState, useRef, useEffect } from "react";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";
import { PageBar, SSPCommonButton, SSPCommonVideo, } from "../../CommonComponents";
import Grid from "@mui/material/Grid";
import { Box, Card, CardContent, CardHeader, Divider, Link, Button, } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { post } from "../../services";
import Cookies from "js-cookie";
import Loader from "../../CommonComponents/Loader";
import axios from "axios";
import styles, { boxSX, columns } from "./Styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { isDevelopment } from "../../Hooks/constants";

const QrControl = ({ token }) => {
    const id = Cookies.get("ssp_id");

    // Dynamic Base URL based on Environment Variables
    const base = isDevelopment
        ? `${process.env.REACT_APP_MDM_DEV || process.env.REACT_APP_SSP_MDM_DEV}`
        : `${process.env.REACT_APP_MDM_PROD || process.env.REACT_APP_SSP_MDM_PROD}`;
    const [loading, setLoading] = useState(false);
    const [loc, setLoc] = useState("");
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [locationCode, setLocationCode] = useState("");
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [row, setRows] = useState([]);

    useEffect(() => {
        rowFetch();
    }, []);

    const rowFetch = async () => {
        setLoading(true)
        let response = await post(
            base,
            {
                "action": "get_uploaded_filesdata",
                rawPath: "/item_nm_qr",
            },
            true,
            false
        );
        if (response?.status === "success") {
            const rowsData = response?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setRows(rowsData);
            setLoading(false)
        } else {
            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
            setLoading(false)

        }
    };


    const downloadProcessLog = async (logId) => {
        setLoading(true)

        let response = await post(
            base,
            {
                "action": "download_data",
                "type": "PROCESS_LOG",
                "log_id": logId,
                rawPath: "/item_nm_qr",
            },
            true,
            false
        );
        if (response?.status === "success") {
            setLoading(false)
            window.open(response?.data_url);

        } else {
            setLoading(false)
            setmessage(response?.body?.message || response?.message);
            setmodalOpener(true);
        }
    }

    const handleUpload = async () => {
        if (selectedFile) {
            if (selectedFile instanceof File) {
                const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
                if (fileExtension !== "xlsx") {
                    setmessage("Only .xlsx files are allowed.");
                    setmodalOpener(true);
                    return;
                }
            }
            setLoading(true)
            let filenameWithTimestamp;
            if (selectedFile instanceof File) {
                const timestamp = new Date()
                    .toISOString()
                    .replace(/[-:.]/g, "")
                    .slice(0, 15);
                filenameWithTimestamp = `${selectedFile?.name
                    .split(".")
                    .slice(0, -1)
                    .join(".")}_${timestamp}.${selectedFile?.name?.split(".")?.pop()}`;
            } else {
                filenameWithTimestamp = selectedFile;
            }
            let presignedUrlResponse = await post(
                base,
                {
                    "action": "gen_post_url",
                    "file_name": filenameWithTimestamp?.replace(/[()]/g, ""),
                    rawPath: "/item_nm_qr",
                },
                true,
                false
            );
            if (presignedUrlResponse?.status === 'error') {
                setmessage(presignedUrlResponse?.data?.message);
                setmodalOpener(true);
                return
            }
            console.log('presignedUrlResponse===>', presignedUrlResponse.body)

            const presignedUrl = presignedUrlResponse.body;

            if (!presignedUrl) {
                console.error("Presigned URL is not valid");
                return;
            }
            if (selectedFile instanceof File) {
                const fileUploaded = await uploadFileWithPresignedUrl(
                    selectedFile,
                    presignedUrl
                );
                if (fileUploaded) {
                    let response = await post(
                        base,
                        {
                            "action": "save_item_details",
                            "items_filename": presignedUrl.fields.key,
                            rawPath: "/item_nm_qr",
                        },
                        true,
                        false
                    );
                    if (response?.status === "success" || response?.status === "Success") {

                        setLoading(false)
                        setmessage(response?.message || "File Uploaded");
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);

                    } else if (response?.status === "Error" || response?.status === "error") {
                        setLoading(false)

                        setmessage(response?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    }

                    else {
                        setLoading(false)

                        setmessage(response?.body?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    }

                }

                if (!fileUploaded) {
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    setLoading(false)
                    setSelectedFile(null);

                    console.error("File upload failed");
                    return;
                }
            }

        } else {
            setLoading(false)
            setmessage("Please select file to upload");
            setmodalOpener(true);
        }
    }
    const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
        try {
            const fileUploadData = new FormData();
            Object.keys(generatedUrl.fields).forEach((key) => {
                fileUploadData.append(key, generatedUrl.fields[key]);
            });
            fileUploadData.append("file", filetoUpload);
            const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);
            if (fileUploaded) {
                return true;
            } else {
                console.error("File upload failed");
                return false;
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const uploadFile = async (url, formData) => {
        try {
            const response = await axios.post(url, formData);

            if (response.status === 204) {
                console.log("File upload successful with status 204");
                return true;
            }

            if (response.status >= 200 && response.status < 300) {
                console.log("File upload successful");
                return true;
            } else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const handleDownloadSampleFile = async () => {
        setLoading(true)

        let response = await post(
            base,
            {
                "action": "download_data",
                "type": "SAMP",
                rawPath: "/item_nm_qr",
            },
            true,
            false
        );

        if (response?.status === "success") {
            setLoading(false)
            window.open(response?.data_url);
        } else {
            setLoading(false)

            setmessage(response?.message);
            setmodalOpener(true);
        }

    };

    const handleDownloadItemMaster = async () => {
        setLoading(true)
        let response = await post(
            base,
            {
                "action": "download_data",
                "type": "ITEM_MASTER",
                rawPath: "/item_nm_qr",
            },
            true,
            false
        );

        if (response?.status === "success") {
            setLoading(false)
            window.open(response?.data_url);
        } else {
            setLoading(false)

            setmessage(response?.message);
            setmodalOpener(true);
        }

    };
    return (
        <Box>
            <Loader loading={loading} />
            <PageBar
                text="Fusion : Asset Management : QR Control"
            />
            <Card sx={styles.assetmasterCard} >

                <CardHeader
                    p={2}
                    sx={styles.cardHeader}
                    title={" Upload excel containing item data"}
                    titleTypographyProps={{
                        sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                    }}
                />
                <Divider />
                <CardContent sx={styles.assetmasterCardContent} >
                    <Grid container spacing={2} >
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4} sx={styles.locContainer} >
                            <Box p={2} sx={styles.fileStyle} >
                                <Box p={1} sx={styles.fileInputStyle} >
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        multiple={false}
                                        onChange={(e) => {
                                            setSelectedFile(e.target.files[0]);
                                        }}

                                    />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3.5} xl={4} sx={{ ...styles.dwnldAssetMasterbttnStyle }} >
                            <SSPCommonButton
                                btnText="Save data"
                                btnFunction={() => {
                                    handleUpload()
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Box p={1} sx={styles.buttonBox} >
                        <Link
                            component={"button"}
                            color={"#0160F1"}
                            sx={boxSX}
                            onClick={handleDownloadSampleFile}
                        >
                            {"Download Sample File"}
                        </Link>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={styles.deviderStyle}
                        />
                        <Link
                            component={"button"}
                            color={"#0160F1"}
                            sx={boxSX}
                            onClick={handleDownloadItemMaster}
                        >
                            {"Download Item Master"}
                        </Link>

                    </Box>
                </CardContent>
                <Card sx={styles.card} >
                    <CardHeader
                        p={2}
                        sx={styles.cardHeader}
                        title={"Uploaded Files"}
                        titleTypographyProps={{
                            sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                        }}
                        action={
                            <>
                                <Button onClick={() => window.location.reload()}>
                                    Refresh Page
                                </Button>
                            </>
                        }
                    />
                    <Divider />
                    <CardContent sx={styles.assetmasterCardContent} >
                        <div>
                            <div style={{ height: 700, width: '100%' }}>
                                <DataGrid
                                    rowHeight={80}
                                    showCellRightBorder={true}
                                    sx={{
                                        ".MuiDataGrid-columnHeaderTitle": {
                                            fontWeight: "bold !important",
                                        },
                                        overflowX: "scroll",
                                    }}
                                    rows={row}
                                    columns={columns(downloadProcessLog)}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 10,
                                            },
                                        },
                                    }}
                                    headerClassName="header-center"
                                    rowsPerPageOptions={[10]}
                                    pageSize={10}
                                    getRowId={(row) => row.id}
                                    components={{
                                        Toolbar: GridToolbar,
                                    }}
                                    componentsProps={{
                                        Toolbar: {
                                            showQuickFilter: true,
                                            quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                />
                            </div>
                        </div>

                        {modalOpener && (
                            <SSPCommonModal
                                open={modalOpener}
                                handleOpenClose={setmodalOpener}
                                message={message}
                            />
                        )}
                    </CardContent>
                </Card>
            </Card>
            {modalOpener && (
                <SSPCommonModal
                    open={modalOpener}
                    handleOpenClose={setmodalOpener}
                    message={message}
                />
            )}

            {/* Video  */}
            <SSPCommonVideo
                headerText={"Demo Video"}
                videoUrl={
                    "https://learn.more.in/learnings/Asset%20Management%20Portal?lesson=qr-control"
                }
            />

        </Box>
    )
}

export default QrControl

